export default __webpack_public_path__ + "static/media/play-button.8e2bb163.svg";